export const NewIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor">
    <path
      d="M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14
	S23.7,2,16,2z"
    />
    <polygon points="24,15 17,15 17,8 15,8 15,15 8,15 8,17 15,17 15,24 17,24 17,17 24,17 " />
  </svg>
);
